export const hexToHue = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;

  if (max === min) {
    h = 0;
  } else if (max === r) {
    h = (60 * (g - b)) / (max - min);
  } else if (max === g) {
    h = (60 * (b - r)) / (max - min) + 120;
  } else if (max === b) {
    h = (60 * (r - g)) / (max - min) + 240;
  }
  if (h < 0) {
    h += 360;
  }

  return h;
};

export const COLORS = ['#FF003C', '#DD00FF', '#0600FF', '#00FFF9', '#38FF04', '#FFFA00', '#FE2801'];

const getHexFromColor = (color: string) => color.split('#')[1];
const getRed = (color: string) => getHexFromColor(color).substring(0, 2);
const getGreen = (color: string) => getHexFromColor(color).substring(2, 4);
const getBlue = (color: string) => getHexFromColor(color).substring(4, 6);

// Accepts hex numbers only
const mixColors = (firstColor: string, secondColor: string, progress: number) => {
  const firstColorNumber = parseInt(firstColor, 16);
  const secondColorNumber = parseInt(secondColor, 16);

  return Math.floor(firstColorNumber + (secondColorNumber - firstColorNumber) * progress);
};

const formatHexColor = (colorInt: number) => `0${colorInt.toString(16)}`.slice(-2);

export const calculateSelectedColor = (position: number) => {
  let currentColor: string;
  const positionInColorsArray = (1 - position / 360) * (COLORS.length - 1);
  const index = Math.trunc(positionInColorsArray);
  const remainder = positionInColorsArray - index;

  if (remainder === 0) {
    currentColor = COLORS[index];
  } else {
    const firstColor = COLORS[index];
    const secondColor = COLORS[index + 1];

    const firstRed = getRed(firstColor);
    const secondRed = getRed(secondColor);
    const red =
      firstRed === secondRed
        ? Math.floor(parseInt(firstRed, 16))
        : mixColors(firstRed, secondRed, remainder);

    const firstGreen = getGreen(firstColor);
    const secondGreen = getGreen(secondColor);
    const green =
      firstGreen === secondGreen
        ? Math.floor(parseInt(firstGreen, 16))
        : mixColors(firstGreen, secondGreen, remainder);

    const firstBlue = getBlue(firstColor);
    const secondBlue = getBlue(secondColor);
    const blue =
      firstBlue === secondBlue
        ? Math.floor(parseInt(firstBlue, 16))
        : mixColors(firstBlue, secondBlue, remainder);

    currentColor = `#${formatHexColor(red)}${formatHexColor(green)}${formatHexColor(blue)}`;
  }

  return currentColor;
};
